module.exports = __webpack_public_path__ + "img/img_quanyi02@2x.b9298eb3.png";